// Opening move: Ensure the cursor starts at the top of the editor on load
// Big play: After the initial editor state is ready, collapse selection to the root start

import { useEffect } from 'react'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $getRoot } from 'lexical'

export default function InitialSelectionPlugin(): null {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    let cancelled = false

    const frameId = requestAnimationFrame(() => {
      if (cancelled) return

      editor.update(() => {
        const root = $getRoot()
        root.selectStart()
      }, { tag: 'initial-selection' })
    })

    return () => {
      cancelled = true
      cancelAnimationFrame(frameId)
    }
  }, [editor])

  return null
}
